"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _toConsumableArray2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _Export2Excel = require("@/vendor/Export2Excel");
var _index = _interopRequireDefault(require("@/components/UploadExcel/index.vue"));
var customer = _interopRequireWildcard(require("@/api/customer"));
var user = _interopRequireWildcard(require("@/api/user"));
var _initStore = require("@/store/initStore");
var _ghn = require("@/api/ghn");
var ImportModal = /*#__PURE__*/function (_Vue) {
  function ImportModal() {
    var _this;
    (0, _classCallCheck2.default)(this, ImportModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ImportModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "modalWidth", "600px");
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "tabName", "");
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "cities", []);
    (0, _defineProperty2.default)(_this, "districts", []);
    (0, _defineProperty2.default)(_this, "wards", []);
    (0, _defineProperty2.default)(_this, "staffs", []);
    (0, _defineProperty2.default)(_this, "keyValid", {
      Name: "name",
      Phone: "phone",
      Email: "email",
      Birthday: "birthday",
      Gender: "gender",
      "Skin status": "skinStatusIds",
      Rank: "customerRank",
      Staff: "staffId",
      Group: "customerGroup",
      Source: "customerSource",
      City: "city",
      District: "district",
      Ward: "ward",
      Address: "receiverAddress",
      Notes: "note",
      "Company name": "companyName",
      "Tax code": "taxCode",
      Website: "website"
    });
    (0, _defineProperty2.default)(_this, "districtIds", []);
    return _this;
  }
  (0, _inherits2.default)(ImportModal, _Vue);
  return (0, _createClass2.default)(ImportModal, [{
    key: "created",
    value: function created() {
      this.fetchCities();
      this.fetchDistricts();
      this.fetchstaff();
    }
  }, {
    key: "transformCity",
    value: function transformCity(text) {
      if (!text) {
        return "";
      }
      var city = text.replace(/(TP )|(Thành phố )/, "");
      return city.replace(" - ", "-");
    }
  }, {
    key: "transformDistrict",
    value: function transformDistrict(text) {
      if (!text) {
        return "";
      }
      return text.replace(/(Quận )|(Thành phố )|(TP )|(Huyện )|(Thị trấn )/, "");
    }
  }, {
    key: "transformWard",
    value: function transformWard(text) {
      if (!text) {
        return "";
      }
      return text.replace(/(Phường )|(Xã )/, "");
    }
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this2 = this;
        var _loop, i;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              this.loading = true;
              _loop = /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _loop() {
                var item, tmp, customerRank, customerSource, customerGroup, skinStatusIds, city, district, ward, data, resCustomer, customerSearch;
                return (0, _regeneratorRuntime2.default)().wrap(function _loop$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      item = _this2.data[i];
                      tmp = {};
                      Object.keys(item).forEach(function (key) {
                        var k = _this2.keyValid[key];
                        tmp[k] = item[key];
                      });
                      customerRank = _initStore.customerRankStore.list.find(function (e) {
                        return e.name == tmp.customerRank;
                      });
                      customerSource = _initStore.customerSourceStore.list.find(function (e) {
                        return e.name == tmp.customerSource;
                      });
                      customerGroup = _initStore.customerGroupStore.list.find(function (e) {
                        return e.name == tmp.customerGroup;
                      });
                      skinStatusIds = [];
                      if (tmp.skinStatusIds) {
                        tmp.skinStatusIds.split("-").forEach(function (e) {
                          var skinFind = _initStore.skinStatusStore.list.find(function (skin) {
                            return skin.name == e;
                          });
                          if (skinFind) {
                            skinStatusIds.push(skinFind.id);
                          }
                        });
                      }
                      city = _this2.cities.find(function (e) {
                        return _this2.transformCity(e.ProvinceName) == _this2.transformCity(tmp.city);
                      });
                      district = city && _this2.districts.find(function (e) {
                        return e.ProvinceID == city.ProvinceID && _this2.transformDistrict(e.DistrictName) == _this2.transformDistrict(tmp.district);
                      });
                      _context.next = 12;
                      return _this2.fetchWards(district && district.DistrictID);
                    case 12:
                      ward = district && _this2.wards.find(function (e) {
                        return e.DistrictID == district.DistrictID && _this2.transformWard(e.WardName) == _this2.transformWard(tmp.ward);
                      });
                      delete tmp.city;
                      delete tmp.district;
                      delete tmp.ward;
                      delete tmp.customerRank;
                      delete tmp.customerSource;
                      delete tmp.customerGroup;
                      delete tmp.skinStatusIds;
                      data = {
                        customer: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, tmp), {}, {
                          receiverCityName: city && city.ProvinceName,
                          receiverCityId: city && city.ProvinceID,
                          receiverCityCode: city && city.Code,
                          receiverDistrictName: district && district.DistrictName,
                          receiverDistrictId: district && district.DistrictID,
                          receiverDistrictCode: district && district.Code,
                          receiverWardName: ward && ward.WardName,
                          receiverWardCode: ward && ward.WardCode
                        }),
                        staffId: tmp.staffId,
                        skinStatusIds: skinStatusIds,
                        customerGroupId: customerGroup && customerGroup.id,
                        customerSourceId: customerSource && customerSource.id,
                        customerRankId: customerRank && customerRank.id
                      };
                      _context.prev = 21;
                      _context.next = 24;
                      return customer.findAll({
                        search: tmp.phone
                      });
                    case 24:
                      resCustomer = _context.sent;
                      if (!(resCustomer.data.customers.length == 1)) {
                        _context.next = 31;
                        break;
                      }
                      customerSearch = resCustomer.data.customers[0];
                      _context.next = 29;
                      return customer.update(customerSearch.id, data);
                    case 29:
                      _context.next = 33;
                      break;
                    case 31:
                      _context.next = 33;
                      return customer.createBatch(data);
                    case 33:
                      _context.next = 37;
                      break;
                    case 35:
                      _context.prev = 35;
                      _context.t0 = _context["catch"](21);
                    case 37:
                    case "end":
                      return _context.stop();
                  }
                }, _loop, null, [[21, 35]]);
              });
              i = 0;
            case 4:
              if (!(i < this.data.length)) {
                _context2.next = 9;
                break;
              }
              return _context2.delegateYield(_loop(), "t0", 6);
            case 6:
              i++;
              _context2.next = 4;
              break;
            case 9:
              this.$message.success("Nhập vào hệ thống thành công!");
              this.visible = false;
              this.$emit("import:success");
            case 12:
              _context2.prev = 12;
              this.loading = false;
              return _context2.finish(12);
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee, this, [[0,, 12, 15]]);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "checkField",
    value: function checkField() {
      var _this3 = this;
      var flag = true;
      var _iterator = (0, _createForOfIteratorHelper2.default)(this.data),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var el = _step.value;
          Object.keys(el).forEach(function (key) {
            if (!_this3.keyValid[key]) {
              flag = false;
            }
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (!flag) {
        throw "Các trường dữ liệu không hợp lệ, vui lòng kiểm tra lại!";
      }
    }
  }, {
    key: "handleUploadSuccess",
    value: function handleUploadSuccess(data) {
      try {
        this.data = data.results;
        this.$message.success('Đã có dữ liệu, vui lòng nhấn "Submit" để nhập vào hệ thống');
      } catch (error) {
        this.data = [];
        this.$message.error(error);
      }
    }
  }, {
    key: "fetchCities",
    value: function () {
      var _fetchCities = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _ghn.ghnApi.findCity();
            case 2:
              res = _context3.sent;
              this.cities = res.data.data;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this);
      }));
      function fetchCities() {
        return _fetchCities.apply(this, arguments);
      }
      return fetchCities;
    }()
  }, {
    key: "fetchDistricts",
    value: function () {
      var _fetchDistricts = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _ghn.ghnApi.findDistrict({
                province_id: null
              });
            case 2:
              res = _context4.sent;
              this.districts = res.data.data;
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee3, this);
      }));
      function fetchDistricts() {
        return _fetchDistricts.apply(this, arguments);
      }
      return fetchDistricts;
    }()
  }, {
    key: "fetchWards",
    value: function () {
      var _fetchWards = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(id) {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(!id || this.districtIds.includes(id))) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              _context5.next = 4;
              return _ghn.ghnApi.findWard({
                district_id: id
              });
            case 4:
              res = _context5.sent;
              this.districtIds.push(id);
              this.wards = [].concat((0, _toConsumableArray2.default)(this.wards), (0, _toConsumableArray2.default)(res.data.data));
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee4, this);
      }));
      function fetchWards(_x) {
        return _fetchWards.apply(this, arguments);
      }
      return fetchWards;
    }()
  }, {
    key: "fetchstaff",
    value: function () {
      var _fetchstaff = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return user.getList({});
            case 2:
              res = _context6.sent;
              this.staffs = res.data.data;
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee5, this);
      }));
      function fetchstaff() {
        return _fetchstaff.apply(this, arguments);
      }
      return fetchstaff;
    }()
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      this.visible = true;
      this.tabName = "import";
    }
  }, {
    key: "handleDownloadSample",
    value: function handleDownloadSample() {
      // exportCustomerExcel();
      var header = ["Name", "Phone", "Email", "Birthday", "Gender", "Skin status", "Rank", "Staff", "Group", "Source", "City", "District", "Ward", "Address", "Notes", "Company name", "Tax code", "Website"];
      var data = [["Customer 1", "0987654322", "a@gmail.com", "01/01/2021", "MALE", "Mụn trứng cá-Nám, tàn nhang-Da dầu", "Silver", "1", "Retail", "Facebook", "Hồ Chí Minh", "Tân Bình", "15", "223 Lý Thường Kiệt", "Test", "Shiratori", "123456", "google.com"], ["Customer 2", "0987654323", "a@gmail.com", "01/01/2021", "MALE", "Mụn trứng cá", "Silver", "1", "Retail", "Facebook", "Hồ Chí Minh", "Tân Bình", "11", "223 Lý Thường Kiệt", "", "", "", ""]];
      (0, _Export2Excel.export_json_to_excel)({
        header: header,
        data: data,
        ws_name: "SampleImport",
        filename: "ImportCustomer-Sample",
        multiSheet: [this.listStaff()]
      });
    }
  }, {
    key: "listStaff",
    value: function listStaff() {
      var header = ["Id", "Fullname", "Username", "Role", "Email", "Phone", "Status"];
      var data = [];
      this.staffs.forEach(function (e) {
        var dataExport = [e.id, e.name, e.username, e.role && e.role.name, e.email, e.phone, e.isBlocked ? "Block" : "Active"];
        data.push(dataExport);
      });
      return {
        sheetName: "Staff",
        data: data,
        header: header
      };
    }
  }]);
}(_vuePropertyDecorator.Vue);
ImportModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    UploadExcel: _index.default
  }
})], ImportModal);
var _default = exports.default = ImportModal;